var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Drop Point")]), _c('div', {
    staticClass: "mb-6 max-w-sm"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": true
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Hub",
      "placeholder": "Nama drop off point"
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Coordiate latitude",
      "placeholder": "Masukan koordinat lokasi latitude"
    },
    model: {
      value: _vm.payloads.coord_lat,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "coord_lat", $$v);
      },
      expression: "payloads.coord_lat"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Coordiate longitude",
      "placeholder": "Masukan koordinat lokasi longitude"
    },
    model: {
      value: _vm.payloads.coord_lng,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "coord_lng", $$v);
      },
      expression: "payloads.coord_lng"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Jam Operasi",
      "placeholder": "Masukan jam operasi"
    },
    model: {
      value: _vm.payloads.operation_hour_display,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "operation_hour_display", $$v);
      },
      expression: "payloads.operation_hour_display"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "label": "Alamat",
      "placeholder": "Alamat"
    },
    model: {
      value: _vm.payloads.address,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "address", $$v);
      },
      expression: "payloads.address"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Wilayah")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.cities,
      "placeholder": "Pilih wilayah",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedCity,
      callback: function ($$v) {
        _vm.selectedCity = $$v;
      },
      expression: "selectedCity"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Provinsi")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.provinces,
      "placeholder": "Pilih provinsi",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedProvince,
      callback: function ($$v) {
        _vm.selectedProvince = $$v;
      },
      expression: "selectedProvince"
    }
  })], 1), _vm.visibleDistrict ? _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kota / Kabupaten")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.districts,
      "default": _vm.selectedDistrict,
      "placeholder": "Pilih kota",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedDistrict,
      callback: function ($$v) {
        _vm.selectedDistrict = $$v;
      },
      expression: "selectedDistrict"
    }
  })], 1) : _vm._e(), _vm.visibleSubDistrict ? _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kecamatan")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.subDistricts,
      "default": _vm.selectedSubDistrict,
      "placeholder": "Pilih kecamatan",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedSubDistrict,
      callback: function ($$v) {
        _vm.selectedSubDistrict = $$v;
      },
      expression: "selectedSubDistrict"
    }
  })], 1) : _vm._e(), _vm.visibleUrbanVillage ? _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kelurahan")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.urbanVillages,
      "default": _vm.selectedUrbanVillage,
      "placeholder": "Pilih kelurahan",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedUrbanVillage,
      callback: function ($$v) {
        _vm.selectedUrbanVillage = $$v;
      },
      expression: "selectedUrbanVillage"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Kode Hub",
      "disabled": true,
      "placeholder": "Akan terisi otomatis"
    },
    model: {
      value: _vm.payloads.hub_code,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "hub_code", $$v);
      },
      expression: "payloads.hub_code"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("PIC")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama PIC 1",
      "placeholder": "Masukan PIC pertama"
    },
    model: {
      value: _vm.payloads.primary_pic_name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "primary_pic_name", $$v);
      },
      expression: "payloads.primary_pic_name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No Handphone",
      "placeholder": "Masukan no handphone"
    },
    model: {
      value: _vm.payloads.primary_pic_phoneno,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "primary_pic_phoneno", $$v);
      },
      expression: "payloads.primary_pic_phoneno"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama PIC 2",
      "placeholder": "Masukan PIC kedua"
    },
    model: {
      value: _vm.payloads.secondary_pic_name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "secondary_pic_name", $$v);
      },
      expression: "payloads.secondary_pic_name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No Handphone",
      "placeholder": "Masukan no handphone"
    },
    model: {
      value: _vm.payloads.secondary_pic_phoneno,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "secondary_pic_phoneno", $$v);
      },
      expression: "payloads.secondary_pic_phoneno"
    }
  })], 1)])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }